import React, {useEffect, useState} from 'react';
import './SessionItemBlock.scss';
import {
    AgentsIcon,
    ArrowDownIcon,
    DeletingIcon,
    EditIcon,
    EllipsisIcon,
    FilterCheckIcon,
    FiltersIcon
} from "../../../../image";
import {Text} from "../../../../modules";
import styles from "../ChatListTopPanel/ChatListTopPanel.module.scss";
import {Popover, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import ModalAgent from "../../../../pages/AiAgentsPage/components/ModalAgent/ModalAgent";

const SessionItemBlock = ({
                              data,
                              handleKeyDown,
                              deleteSession,
                              handleOpenChange,
                              editSessionId,
                              setChangeName,
                              changeName,
                              onHandleClickSession,
                              inputRef,
                              setEditSessionId,
                              open
                          }) => {
    const {t} = useTranslation();
    const selectedIdSession = useSelector(state => state.chat.selectedIdSession);
    const [openBlock, setOpenBlock] = useState(false);
    const countNotReadSessions = (data?.children || []).filter((item) => !item?.is_read).length;
    const agentsInfo = useSelector(state => state.agents.agentsInfo?.agents || []);
    const findAgent = agentsInfo?.find((agent) => agent?.id === data?.agent_id);
    const [isVisibleModal, setIsVisibleModal] = useState(false);

    useEffect(()=>{
        if((data?.children || []).some((item) => item?.id === selectedIdSession)){
            setOpenBlock(true)
        }
    },[])
    const RenderSessionTitle = ({item}) => {
        return (
            <>
                {editSessionId === item?.id ?
                    <input
                        ref={inputRef}
                        className="chats-list__feed--item-input"
                        onChange={(e) => setChangeName(e?.target?.value || '')}
                        value={changeName}
                        onKeyDown={handleKeyDown}
                    />
                    :
                    <div
                        className={`chats-list__feed--item ${selectedIdSession === item?.id ? 'chats-list__feed--item-active' : ''}`}
                        onClick={() => onHandleClickSession(item)}
                        id={`session-item-${item?.id}`}
                    >
                        <Text
                            size="f14"
                            font={selectedIdSession === item?.id ? 'liteMedium' : 'book'}
                            color={selectedIdSession === item?.id ? 'black' : '#4A4A4A'}
                            className="chats-list__feed--item-text"
                        >
                            {item.summary || 'New chat'}
                        </Text>
                        {!item?.is_read ? <div className="chats-list__feed--item-badge"/> : null}
                        <Popover
                            arrow={false}
                            trigger='hover'
                            placement="bottomLeft"
                            open={open === item?.id}
                            overlayClassName='popover_edit-menu'
                            onOpenChange={(e) => handleOpenChange(e, item?.id)}
                            // getPopupContainer={() => document.getElementById(`session-item-${item?.id}`)}
                            content={
                                <>
                                    <div
                                        className={'popover_edit-menu--item'}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEditSessionId(item?.id);
                                            setChangeName(item?.summary)
                                        }}
                                    >
                                        <EditIcon className={''}/> {t('button_edit')}
                                    </div>
                                    <div
                                        className={'popover_edit-menu--item delete'}
                                        onClick={(e) => {
                                            deleteSession(item?.id)
                                        }}
                                    >
                                        <DeletingIcon className={''}/> {t('button_delete')}
                                    </div>
                                </>
                            }
                        >
                            <div className="popover_edit-menu--settings"
                                 onClick={(e) => e.stopPropagation()}>
                                <EllipsisIcon/>
                            </div>
                        </Popover>
                    </div>
                }
            </>
        )
    }

    const onHandleClickBlock = () => {
        setOpenBlock(!openBlock);
        if(!openBlock){
            const session = (data?.children || [])?.[0];
            onHandleClickSession(session)
        }
    }

    return (
        <div className='session-item'>
            {data?.agent_id ?
                <div
                    onClick={onHandleClickBlock}
                    className='session-item__title'>
                    <AgentsIcon className='session-item__title--icon'/>
                    <Text size="f14" font="liteMedium" color="black" className='session-item__title--text'>
                        {findAgent?.name}
                    </Text>
                    <div className='session-item__actions'>
                        <Tooltip
                            placement="top"
                            title={t('tooltip_settings_session')}
                        >
                            <FiltersIcon
                                className='session-item__title--icon'
                                onClick={(e)=>{
                                    e.stopPropagation();
                                    console.log('EEEE')
                                    setIsVisibleModal(true);
                                }}
                            />
                        </Tooltip>

                            <div className='session-item__actions--count-block'>
                                <ArrowDownIcon
                                    className={`session-item__title--arrow ${openBlock ? 'session-item__title--active' : ''}`}
                                />
                                {countNotReadSessions ?
                                <Text size="f13" className='session-item__actions--count'
                                      color="white">{countNotReadSessions}</Text> :
                                    null
                                }
                            </div>
                    </div>
                </div>
                :
                <RenderSessionTitle item={data}/>
            }
            {(data?.children || []).length ?

                <div className='session-item__list'
                     style={{
                         height: openBlock ? `${(data?.children || []).length * 36 + (8 * (data?.children || []).length - 1)}px` : '0',
                         margin: openBlock ? '8px 0 8px 24px' : '0',
                         opacity: openBlock ? '1' : '0',
                }
                }
                >
                    {(data?.children || []).map((item) => (
                        <RenderSessionTitle item={item}/>
                    ))}
                </div>
                :
                null}
            <ModalAgent
                agentId={data?.agent_id}
                show={isVisibleModal}
                onClose={() => setIsVisibleModal(false)}
            />
        </div>
    );
};

export default SessionItemBlock;